import { formatLocalFullDateLabel, toLocalYMD } from '../../../utils/dateUtils';
import {
  huntDeerSeenCount,
  huntIsClubGround,
} from '../../../utils/huntLogFilters';

const MONTHS = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];

/**
 * Date chip for My Hunts list rows (MON + day numeral).
 * @param {string|Date} dateLike
 * @returns {{ mon: string, day: string }}
 */
export function buildHuntDateChip(dateLike) {
  const ymd = toLocalYMD(dateLike);
  if (!ymd || ymd.length < 10) return { mon: '—', day: '—' };
  const monthIdx = Number(ymd.slice(5, 7)) - 1;
  const day = String(Number(ymd.slice(8, 10)));
  return {
    mon: MONTHS[monthIdx] || '—',
    day: Number.isFinite(Number(day)) ? day : '—',
  };
}

/**
 * Prototype date-chip fill: harvest → rust, nothing seen → tan, else loden.
 * @param {object} hunt
 * @returns {'harvest'|'blank'|'seen'}
 */
export function huntDateChipTone(hunt) {
  if (hunt?.harvest) return 'harvest';
  if (huntDeerSeenCount(hunt) === 0) return 'blank';
  return 'seen';
}

/** Full mono date label for grid card headers. */
export function formatHuntEntryFullDate(dateLike) {
  return formatLocalFullDateLabel(dateLike) || '—';
}

export function huntGroundLabel(hunt) {
  return huntIsClubGround(hunt) ? 'Club ground' : 'My ground';
}

export function formatHuntTimePeriods(periods) {
  if (!periods || periods.length === 0) return '—';
  return periods
    .map((period) => String(period).charAt(0).toUpperCase() + String(period).slice(1).replace(/_/g, ' '))
    .join(', ');
}

export function formatHuntDeerLine(hunt) {
  const does = Number(hunt?.does_seen) || 0;
  const bucks = Number(hunt?.bucks_seen) || 0;
  const fawns = Number(hunt?.fawns_seen) || 0;
  return `Does ${does} · Bucks ${bucks} · Fawns ${fawns}`;
}

export { huntDeerSeenCount };
